<template>
    <div class="row" id="all_feedback">
        <div class="col-md-12" style="margin-bottom: 20px;">
            <lazy-load ref="loadMore"
                       :initial-endpoint="fetch_endpoint"
                       :page-name="pagination_name"
                       :page-limit="pagination_limit"
                       :params="{'model_id': model_id, 'model_type': model_type}"
                       :trans-load-more="trans_load_more">
                <div class="review" slot="list" slot-scope="{ index, result }" style="min-height: 111px;">
                    <div v-if="result.user">
                        <a :href="result.user.userpage_link" class="review-image no-overflow flex-wrap-v-center">
                            <img :src="result.user.image" :alt="result.user.full_name" class="review_image">
                            <span class="user_name text-center" :title="result.user.full_name">
                                {{ result.user.full_name }}
                            </span>

                            <star-rating v-if="result.rating"
                                         active-color="#739745"
                                         :read-only="true"
                                         :rating="result.rating"
                                         :show-rating="false"
                                         :inline="true"
                                         :star-size="15">
                            </star-rating>
                        </a>
                    </div>
                    <div v-else class="review-image no-overflow flex-wrap-v-center">
                        <star-rating v-if="result.rating"
                                     active-color="#739745"
                                     :read-only="true"
                                     :rating="result.rating"
                                     :show-rating="false"
                                     :inline="true"
                                     :star-size="15">
                        </star-rating>
                    </div>

                    <div class="review-inner">
                        <div class="review-content-wrapper">
                            <div class="review-content">
<!--                                <h4 v-if="result.title" class="font-bold" :title="result.title">-->
<!--                                    {{ result.title | strip_tags | str_limit(60) }}-->
<!--                                </h4>-->
                                <div v-if="result.title && result.company" class="flex flex-wrap justify-between mb-4">
                                    <strong>
                                        <a :href="result.company.url" :title="result.company.name">
                                            {{ result.company.name }}, {{ result.company.city.name }}
                                        </a>
                                    </strong>
                                </div>

                                <div v-if="result.comment || result.old_comment">
                                    <div v-if="result.autoTranslated">
                                        <read-more :more-str="open_read_more"
                                                   :text="result.comment !== null ? result.comment : result.old_comment"
                                                   link="#"
                                                   :less-str="close_read_more"
                                                   :max-chars="250">
                                        </read-more>
                                        <template v-if="result.old_comment">
                                            <hr/>
                                            <read-more :more-str="open_read_more"
                                                       :text="result.old_comment"
                                                       link="#"
                                                       :less-str="close_read_more"
                                                       :max-chars="250">
                                            </read-more>
                                        </template>
                                        <hr/>
                                        <p>{{ feedback_auto_translated_text }}</p>
                                    </div>
                                    <div v-else>
                                        <read-more :more-str="open_read_more"
                                                   :text="result.comment !== null ? result.comment : result.old_comment"
                                                   link="#"
                                                   :less-str="close_read_more"
                                                   :max-chars="250">
                                        </read-more>
                                    </div>
                                </div>
                                <div v-else>
                                    -
                                </div>

                                <p class="mt-3 pt-3" :id="'original-' + index" style="border-top: 1px solid #eeeeee;"
                                   hidden></p>

                                <div class="row" v-if="result.custom_properties !== null">
                                    <div class="col-md-6"
                                         v-for="(rating, rating_name) in JSON.parse(result.custom_properties)"
                                         :key="rating_name">
                                        <span v-text="rating_trans[rating_name]"></span>
                                        <br>
                                        <star-rating active-color="#808080"
                                                     :read-only="true"
                                                     :rating="parseFloat(rating)"
                                                     :show-rating="false"
                                                     :inline="true"
                                                     :star-size="12">
                                        </star-rating>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </lazy-load>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        rating_translations: {
            type: String,
            required: true
        },
        open_read_more: {
            type: String,
            required: true
        },
        close_read_more: {
            type: String,
            required: true
        },
        feedback_auto_translated_text: {
            type: String,
            required: true
        },
        trans_load_more: {
            type: String,
            required: true
        },
        fetch_endpoint: {
            type: String,
            required: true
        },
        pagination_name: {
            type: String,
            required: true
        },
        pagination_limit: {
            type: Number,
            required: true
        },
        model_id: {
            type: Number,
            required: true
        },
        model_type: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            rating_trans: {}
        };
    },

    mounted() {
        this.rating_trans = JSON.parse(this.rating_translations);

        this.$refs.loadMore.fetch();
    }
};
</script>

<style>
.no-overflow {
    overflow: inherit !important;
}

.review-image img {
    width: 60px !important;
    height: 60px !important;
}

.user_name {
    width: 68%;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: rgba(54, 54, 54, 0.6);
}

.review-image {
    width: 100px;
}

.review_image {
    margin-bottom: 10px;
    border-radius: 50%;
}

.review-content {
    padding: 0 !important;
}

.review-inner {
    margin: 0 0 0 140px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Feedback.vue